module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0023.jpg?v=a04f2381";